export default function WindHero() {
  return (
    <section className="relative min-h-[88vh] flex items-center overflow-hidden pt-16">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20wide-angle%20landscape%20of%20large%20commercial%20wind%20turbines%20standing%20tall%20across%20golden%20Australian%20farmland%20at%20sunset%2C%20warm%20orange%20and%20amber%20sky%2C%20rolling%20hills%2C%20cinematic%20scale%20and%20depth%2C%20premium%20editorial%20energy%20photography%2C%20epic%20renewable%20energy%20landscape&width=1800&height=900&seq=wind-hero-au-2026&orientation=landscape"
          alt="Commercial wind turbines generating clean energy across Australian farmland"
          className="w-full h-full object-cover object-center"
        />
        {/* Strong left-to-right dark ramp so text area is nearly opaque */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/97 via-black/90 to-black/60" />
        {/* Top + bottom fade for depth */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/50" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-10 py-20 md:py-28">
        {/* Backdrop panel behind text for guaranteed contrast */}
        <div
          className="max-w-3xl rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.20) 100%)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            padding: '2rem',
          }}
        >
          <div style={{ textShadow: '0 2px 20px rgba(0,0,0,0.90), 0 1px 6px rgba(0,0,0,0.75)' }}>
            {/* Breadcrumb */}
            <nav aria-label="Breadcrumb" className="flex items-center gap-2 mb-6">
              <a href="/" className="text-xs text-white/70 hover:text-white transition-colors whitespace-nowrap">Home</a>
              <i className="ri-arrow-right-s-line text-white/40 text-xs"></i>
              <span className="text-xs text-white/85 whitespace-nowrap">Wind Energy Solutions</span>
            </nav>

            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-500/25 border border-secondary-400/40 mb-6">
              <i className="ri-windy-line text-secondary-300 text-sm"></i>
              <span className="text-xs font-semibold text-secondary-200 tracking-wide uppercase whitespace-nowrap">Wind Energy Solutions Australia</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-white mb-6">
              Wind Energy<br />
              Solutions<br />
              <span className="text-secondary-300">Australia</span>
            </h1>

            <p className="text-lg md:text-xl text-white leading-relaxed mb-4 max-w-2xl">
              Discover Australia&rsquo;s leading commercial and industrial wind energy solutions. From large-scale wind farms to small wind turbines for remote properties — connect with verified renewable energy providers on AK Energy.
            </p>

            <p className="text-sm md:text-base text-white/80 leading-relaxed mb-8 max-w-xl">
              Australia has world-class wind resources and an ambitious renewable energy target. AK Energy connects businesses, landowners, and communities with the wind energy providers best suited to their needs.
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
              >
                Find Wind Energy Providers
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl bg-white/15 border border-white/30 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer backdrop-blur-sm"
              >
                <i className="ri-file-list-3-line text-lg"></i>
                Request a Wind Assessment
              </a>
            </div>

            {/* Trust bar */}
            <div className="flex flex-wrap items-center gap-6 mt-10 pt-8 border-t border-white/20">
              {[
                { icon: 'ri-shield-check-line', text: 'ARENA-Supported Projects' },
                { icon: 'ri-map-pin-line', text: 'Australia-Wide Coverage' },
                { icon: 'ri-building-2-line', text: 'Commercial & Industrial Focus' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2">
                  <i className={`${item.icon} text-secondary-300 text-base`}></i>
                  <span className="text-xs text-white/85 font-medium whitespace-nowrap">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}